// extracted by mini-css-extract-plugin
export default {"juicyLength":"8px","zIndexPopover":"100"};